var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00026 3.67042e-05C13.9708 3.67042e-05 18.0002 4.02948 18.0002 9.00001C18.0002 13.9705 13.9708 18 9.00026 18C4.02972 18 0.000281471 13.9705 0.000281471 9.00001C-0.0138619 4.04357 3.99262 0.0141801 8.94902 3.67042e-05C8.9661 -1.22347e-05 8.98318 -1.22347e-05 9.00026 3.67042e-05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 7.5,
    width: 3,
    height: 10.5,
    rx: 1.5,
    transform: "rotate(90 14.25 7.5)",
    fill: "#27A4F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 14.25,
    width: 3,
    height: 10.5,
    rx: 1.5,
    transform: "rotate(-180 10.5 14.25)",
    fill: "#27A4F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5031c5e612a82264d8b1a2ce724ba3aa.svg";
export { ForwardRef as ReactComponent };